import type { AgentPageSeo, FAQItem } from "../agent-seo";

export const faqs: FAQItem[] = [
  {
    question: "What is the Live Apply Agent?",
    answer:
      "Live Apply searches job boards in real time, shows you the newest matching roles with a match score, and applies to the ones you select in one click.",
  },
  {
    question: "Which job boards does it search?",
    answer:
      "LinkedIn, Naukri, Indeed, Foundit, Instahyre and Internshala. You can search one board or all of them at once.",
  },
  {
    question: "How fresh are the jobs?",
    answer:
      "You choose. On LinkedIn you can filter to roles posted in the last 15 minutes, the last hour or the last 24 hours, so you apply before most candidates have seen the post.",
  },
  {
    question: "Can I filter by experience, work type and applicants?",
    answer:
      "Yes. Filter by experience level, job type, on-site, remote or hybrid, distance and sort order, and on LinkedIn show only roles with fewer applicants. Your filters are saved for each board.",
  },
  {
    question: "How is the match score calculated?",
    answer:
      "Each job is compared with your profile across skills, experience, location and keywords. Hover the score to see the breakdown.",
  },
  {
    question: "Does it attach a tailored resume?",
    answer:
      "On LinkedIn and Indeed, Live Apply attaches a resume tailored to that job. On other boards it applies with your saved resume.",
  },
  {
    question: "Can I stop it mid-way?",
    answer:
      "Yes. Pause or resume a bulk apply at any time, and see the status of every selected job as it goes.",
  },
];

export const seo: AgentPageSeo = {
  slug: "live-apply",
  name: "Live Apply Agent",
  title: "Live Apply Agent: Apply to Fresh Jobs First | MindMyJob",
  description:
    "Search LinkedIn, Naukri, Indeed and more in real time, filter to jobs posted minutes ago, see a match score and apply to the best ones in one click.",
  keywords: [
    "apply to new jobs first",
    "real time job search",
    "linkedin easy apply automation",
    "naukri auto apply",
    "bulk apply jobs",
    "jobs posted in last hour",
    "one click job apply",
    "job match score",
    "live job alerts apply",
    "early applicant advantage",
  ],
  ogImage: "/assets/images/ai-agents/live-apply/hero-live-jobs.png",
  ogImageAlt:
    "MindMyJob Live Apply Agent showing jobs posted minutes ago with match scores",
  featureList: [
    "Real-time search across six job boards",
    "Posted-within filters down to 15 minutes",
    "Match score with breakdown",
    "Bulk apply with pause and resume",
    "Tailored resume on LinkedIn and Indeed",
    "Saved filters per platform",
  ],
  faqs,
};
